import { render, staticRenderFns } from "./group.component.vue?vue&type=template&id=ef557784&scoped=true&"
import script from "./group.component.vue?vue&type=script&lang=js&"
export * from "./group.component.vue?vue&type=script&lang=js&"
import style0 from "./group.component.vue?vue&type=style&index=0&id=ef557784&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef557784",
  null
  
)

export default component.exports